import React from "react";
import { makeStyles } from "@material-ui/core";

import { useScrollable } from "@hooks";
import { i18n } from "@locales";

type TProps = { list: { text: string; value: number }[]; textSize?: number };

const useStyles = makeStyles({
  tableRoot: {
    display: "block",
    maxHeight: "20rem",
    overflowY: "auto",
    borderCollapse: "separate",
    borderSpacing: "0",
  },
  tableHeaderRow: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
  },
  tableRows: {
    border: "0.1rem solid black",
  },
});

function AccessibleTable({ list, textSize = 1.0 }: TProps) {
  // Font sizes in rem (base: 14px / 10px = 1.4rem)
  const answersFontSize = `${String(1.4 * textSize)}rem`;
  const answersPadding = `${String(0.8 * textSize)}rem`; // 8px / 10px = 0.8rem
  const classes = useStyles();
  const { ref, isScrollable } = useScrollable<HTMLTableElement>([list]);

  return (
    <table
      ref={ref}
      className={classes.tableRoot}
      // that is correct because the table can be scrolled
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isScrollable ? 0 : -1}
      aria-label={i18n.t("surveys.accessible_word_cloud")}
      aria-live="polite"
    >
      <thead>
        <tr>
          <th
            className={`${classes.tableRows} ${classes.tableHeaderRow}`}
            style={{
              padding: answersPadding,
              fontSize: answersFontSize,
            }}
          >
            {i18n.t("surveys.word")}
          </th>
          <th
            className={`${classes.tableRows} ${classes.tableHeaderRow}`}
            style={{
              padding: answersPadding,
              fontSize: answersFontSize,
            }}
          >
            {i18n.t("surveys.frequency")}
          </th>
        </tr>
      </thead>
      <tbody>
        {list.map(({ text, value }) => (
          <tr key={text} className={classes.tableRows}>
            <td
              className={classes.tableRows}
              style={{
                padding: answersPadding,
                fontSize: answersFontSize,
              }}
            >
              {text}
            </td>
            <td
              className={classes.tableRows}
              style={{
                padding: answersPadding,
                fontSize: answersFontSize,
              }}
            >
              {value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default AccessibleTable;
